module.exports = __webpack_public_path__ + "static/media/covid-square.96397144.png";